import { Injectable } from '@angular/core';

/**
 * Translations for tables.
 */
@Injectable()
export class TablesTranslations {

  /* Accordion translations */

  public i18nAddresses: string = $localize`:@@general.accordionHeading.addresses:Addresses`;

  public i18nStandardAddress: string = $localize`:@@general.accordionHeading.standardAddress:Standard Address`;

  public i18nBankingData: string = $localize`:@@general.accordionHeading.bankingData:Banking data`;

  public i18nMembership: string = $localize`:@@general.accordionHeading.membership:Membership`;

  public i18nMembershipCampai: string = $localize`:@@general.accordionHeading.membershipCampai:Membership (Campai)`;

  public i18nLastContacts: string = $localize`:@@general.accordionHeading.lastContacts:Last contacts`;

  public i18nMerchandising: string = $localize`:@@general.accordionHeading.merchandising:Merchandising`;

  public i18nTicketing: string = $localize`:@@general.accordionHeading.ticketing:Ticketing`;

  public i18nCampaignActivity: string = $localize`:@@general.accordionHeading.campaignActivity:Campaign activity`;

  public i18nHistory: string = $localize`:@@general.accordionHeading.history:History`;

  public i18nReminders: string = $localize`:@@general.accordionHeading.reminders:Reminders`;

  public i18nTixxSelect: string = $localize`:@@general.accordionHeading.tixxSelect:Tixx-Select`;

  public i18nFanStatus: string = $localize`:@@general.accordionHeading.fanStatus:Fan Status (CRM Attributes)`;

  public i18nPartnerSpecials: string = $localize`:@@general.accordionHeading.aartnerSpecials:Partners & Specials`;

  public i18nPriceCategory: any = $localize`:@@general.accordionHeading.priceCategory:Price Category`;

  public i18nQuotasPermissions: any = $localize`:@@general.accordionHeading.quotasPermissions:Quotas & Permissions`;

  public i18nPriceReduction: any = $localize`:@@general.accordionHeading.priceReduction:Price Reduction`;

  public i18nRequestedTicketsPerCategory: any = $localize`:@@general.accordionHeading.requestedTicketsPerCategory:Requested tickets per price category`;

  public i18nPrimaryRequestsPerCategory: any = $localize`:@@general.accordionHeading.primaryRequestsPerCategory:Primary requests per price category`;

  public i18nActiveLotteryRounds: any = $localize`:@@general.accordionHeading.activeLotteryRounds:Active lottery rounds`;

  public i18nCompletedLotteryRounds: any = $localize`:@@general.accordionHeading.completedLotteryRounds:Completed lottery rounds`;


  /* Action button translations */

  public i18nCreateNewBankData: string = $localize`:@@general.tooltip.createNewBankData:Create new bank data`;

  public i18nCreateNewContact: string = $localize`:@@general.tooltip.createNewContact:Create a new contact`;

  public i18nCreateNewMembership: string = $localize`:@@general.tooltip.createNewMembership:Create new membership`;

  public i18nCreateNewCampaiMembership: string = $localize`:@@general.tooltip.createNewCampaiMembership:Create new campai membership`;

  public i18nCreateNewReminder: string = $localize`:@@general.tooltip.createNewReminder:Create a new reminder`;

  public i18nRequestPricesFromTixx: string = $localize`:@@general.tooltip.requestPricesFromTixx:Request prices from Tixx`;

  public i18nAddNewPriceReduction: string = $localize`:@@general.tooltip.createNewPriceReduction:Create a new price reduction`;

  public i18nEditTicketQuota: string = $localize`:@@general.tooltip.editTicketQuota:Edit ticket quota`;

  /* Table columns translations */

  public i18nIBAN: string = $localize`:@@general.tableColumn.iban:IBAN`;

  public i18nBIC: string = $localize`:@@general.tableColumn.bic:BIC`;

  public i18nBankName: string = $localize`:@@general.tableColumn.bankName:Bank name`;

  public i18nTimestamp: string = $localize`:@@general.tableColumn.timestamp:Timestamp`;

  public i18nCampaignTitle: string = $localize`:@@general.tableColumn.campaignTitle:Campaign title`;

  public i18nAction: string = $localize`:@@general.tableColumn.action:Action`;

  public i18nDate: string = $localize`:@@general.tableColumn.date:Date`;

  public i18nDateOfSubmission: string = $localize`:@@general.tableColumn.dateOfSubmission:Date of submission`;

  public i18nTitle: string = $localize`:@@general.tableColumn.title:Title`;

  public i18nComment: string = $localize`:@@general.tableColumn.comment:Comment`;

  public i18nAuthor: string = $localize`:@@general.tableColumn.author:Author`;

  public i18nInvoices: string = $localize`:@@general.tableColumn.invoices:Invoices`;

  public i18nInvoiceNr: string = $localize`:@@general.tableColumn.invoiceNumber:Invoice nr.`;

  public i18nCancellationNr: string = $localize`:@@general.tableColumn.cancellationNumber:Cancellation nr.`;

  public i18nReservationNr: string = $localize`:@@general.tableColumn.reservationNumber:Reservation nr.`;

  public i18nEventsAndTickets: string = $localize`:@@general.tableColumn.eventsAndTickets:Events & tickets`;

  public i18nAmount: string = $localize`:@@general.tableColumn.amount:Amount`;

  public i18nAssignedReductions: string = $localize`:@@general.tableColumn.assignedReductions:Assigned reductions`;

  public i18nColor: string = $localize`:@@general.tableColumn.color:Color`;

  public i18nBranch: string = $localize`:@@general.tableColumn.branch:Branch`;

  public i18nStatus: string = $localize`:@@general.tableColumn.status:Status`;

  public i18nHeadline: string = $localize`:@@general.tableColumn.headline:Headline`;

  public i18nAudience: string = $localize`:@@general.tableColumn.audience:Audience`;

  public i18nClicks: string = $localize`:@@general.tableColumn.clicks:Clicks`;

  public i18nSection: string = $localize`:@@general.tableColumn.section:Section`;

  public i18nJoinDate: string = $localize`:@@general.tableColumn.joinDate:Join date`;

  public i18nEnterDate: string = $localize`:@@general.tableColumn.enterDate:Enter date`;

  public i18nDeadline: string = $localize`:@@general.tableColumn.deadline:Deadline`;

  public i18nOwner: string = $localize`:@@general.tableColumn.owner:Owner`;

  public i18nText: string = $localize`:@@general.tableColumn.text:Text`;

  public i18nMembershipNr: string = $localize`:@@general.tableColumn.membershipNr:Membership nr.`;

  public i18nCustNr: string = $localize`:@@general.tableColumn.custNr:Cust. nr.`;

  public i18nCompany: string = $localize`:@@general.tableColumn.company:Company`;

  public i18nFirstName: string = $localize`:@@general.tableColumn.firstName:First name`;

  public i18nLastName: string = $localize`:@@general.tableColumn.lastName:Last name`;

  public i18nSalutation: string = $localize`:@@general.tableColumn.salutation:Salutation`;

  public i18nMobilePhone: string = $localize`:@@general.tableColumn.mobilePhone:Mobile phone`;

  public i18nRole: string = $localize`:@@general.tableColumn.role:Role`;

  public i18nUsername: string = $localize`:@@general.tableColumn.username:Username`;

  public i18nEmail: string = $localize`:@@general.tableColumn.email:Email`;

  public i18nStreet: string = $localize`:@@general.tableColumn.street:Street`;

  public i18nBirthday: string = $localize`:@@general.tableColumn.birthday:Birthday`;

  public i18nCity: string = $localize`:@@general.tableColumn.city:City`;

  public i18nPostalCode: string = $localize`:@@general.tableColumn.postalCode:Postal Code`;

  public i18nPriority: string = $localize`:@@general.tableColumn.priority:Priority`;

  public i18nCustomer: string = $localize`:@@general.tableColumn.customer:Customer`;

  public i18nCustomerData: string = $localize`:@@general.tableColumn.customerData:Customer data`;

  public i18nComunicationData: string = $localize`:@@general.tableColumn.comunicationData:Comunication data`;

  public i18nReference: string = $localize`:@@general.tableColumn.reference:Reference`;

  public i18nLastExecution: string = $localize`:@@general.tableColumn.lastExecution:Last Execution`;

  public i18nType: string = $localize`:@@general.tableColumn.type:Type`;

  public i18nSignaturePlace: string = $localize`:@@general.tableColumn.signaturePlace:Signature Place`;

  public i18nSignatureDate: string = $localize`:@@general.tableColumn.signatureDate:Signature Date`;

  public i18nName: string = $localize`:@@general.tableColumn.name:Name`;

  public i18nClubName: string = $localize`:@@general.tableColumn.clubName:Club name`;

  public i18nEvent: string = $localize`:@@general.tableColumn.event:Event`;

  public i18nLimit: string = $localize`:@@general.tableColumn.limit:Limit`;

  public i18nClubAttributes: string = $localize`:@@general.tableColumn.clubAttributes:Club Attributes`;

  public i18nHomeTeam: string = $localize`:@@general.tableColumn.homeTeam:Home Team`;

  public i18nGuestTeam: string = $localize`:@@general.tableColumn.guestTeam:Guest Team`;

  public i18nCompetition: string = $localize`:@@general.tableColumn.competition:Competition`;

  public i18nVenue: string = $localize`:@@general.tableColumn.venue:Venue`;

  public i18nDescription: string = $localize`:@@general.tableColumn.description:Description`;

  public i18nQuantity: string = $localize`:@@general.tableColumn.quantity:Quantity`;

  public i18nProducts: string = $localize`:@@general.tableColumn.products:Products`;

  public i18nLabel: string = $localize`:@@general.tableColumn.label:Label`;

  /* Empty state translations */

  public i18nAddNewBankAccount: string = $localize`:@@emptyState.button.addNewBankAccount:Add a new bank account`;

  public i18nAddNewFanStatus: string = $localize`:@@emptyState.button.addNewFanStatust:Add a new fan status`;

  public i18nAddNewPartnerSpecial: any = $localize`:@@emptyState.button.addNewPartnerSpecial:Add a new partner or special`;

  public i18nAddNewMembership: string = $localize`:@@emptyState.button.addNewMembership:Add a new membership`;

  public i18nTransferToCampai: string = $localize`:@@emptyState.button.addNewtransferToCampai:Transfer customer to campai`;

  public i18nAddNewReminder: string = $localize`:@@emptyState.button.addNewReminder:Add a new reminder`;

  public i18nNoBankAccounts: string = $localize`:@@emptyState.text.noBankAccounts:There are no bank accounts yet`;

  public i18nNoCampaignActivity: string = $localize`:@@emptyState.text.noCampaignActivity:There is no campaign activity`;

  public i18nAddNewContact: string = $localize`:@@emptyState.button.addNewContact:Add a new contact`;

  public i18nNoContacts: string = $localize`:@@emptyState.text.noContact:There are no contacts yet.`;

  public i18nNoInvoices: string = $localize`:@@emptyState.text.noInvoices:There are no invoices`;

  public i18nNoReservations: string = $localize`:@@emptyState.text.noReservations:There are no reservations`;

  public i18nTooManyReservations: string = $localize`:@@emptyState.text.tooManyReservations:Reservations can't be displayed as there are too many. Please visit Tixx to see all reservations.`;

  public i18nNoCancellations: string = $localize`:@@emptyState.text.noCancellations:There are no cancellations`;

  public i18nNoMembership: string = $localize`:@@emptyState.text.noMembersip:There is no membership`;

  public i18nNoMerchandising: string = $localize`:@@emptyState.text.noMerchandising:There is no merchandise data yet`;

  public i18nNoAddresses: string = $localize`:@@emptyState.text.noAddresses:There are no addresses`;

  public i18nNoAttributes: string = $localize`:@@emptyState.text.noAttributes:There are no attributes`;

  public i18nNoFanStatuses: string = $localize`:@@emptyState.text.noFanStatuses:There are no fan statuses`;

  public i18nNoPartnerSpecials: string = $localize`:@@emptyState.text.noPartnerSpecials:There are no partners or specials`;

  public i18nNoReminder: string = $localize`:@@emptyState.text.noReminder:There are no open reminders`;

  public i18nNoSubmissions: string = $localize`:@@emptyState.text.noSubmissions:There are no submissions`;

  public i18nNoPriceCategories: string = $localize`:@@general.emptyState.noPriceCategories:There are no price categories yet`;

  public i18nNoIterations: string = $localize`:@@general.emptyState.noIterations:There are no iterations yet`;

  public i18nNoPriceReductions: string = $localize`:@@general.emptyState.noPriceReductions:There are no price reductions yet`;

  public i18nNoTicketQuotas: string = $localize`:@@general.emptyState.noTicketQuotas:There are no ticket quotas yet`;

  public i18nTicketsRequested: string = $localize`:@@general.pagination.ticketsRequested:Tickets Requested`;

  public i18nPrimaryRequested: string = $localize`:@@general.pagination.primaryRequested:Primary Requested`;

  public i18nSecondaryRequested: string = $localize`:@@general.pagination.secondaryRequested:Secondary Requested`;

  public i18ntoBeSeatedTicketCount: string = $localize`:@@general.tableColumn.requestsTickets:Tickets to be seated`;

  public i18nSuccessfullySeatedTicketCount: string = $localize`:@@general.tableColumn.requestsSeated:Successfully seated`;

  public i18nRequestsFailed: string = $localize`:@@general.tableColumn.requestsFailed:Requests failed`;

  public i18nAvailableSeats: string = $localize`:@@general.pagination.availableSeats:Available Seats`;

  public i18nAvailability: string = $localize`:@@general.pagination.availability:Availability`;

  public i18nOccupancy: string = $localize`:@@general.pagination.occupancy:Occupancy`;

  public i18nDragMembership: string = $localize`:@@emptyState.text.dragMembership:Drag membership here`;

  public i18nDragAttributes: string = $localize`:@@emptyState.text.dragAttributes:Drag attributes here`;

  public i18nDragAddress: string = $localize`:@@emptyState.text.dragAddress:Drag address here`;

  public i18nActive: string = $localize`:@@emptyState.text.active:Active`;

  public i18nInctive: string = $localize`:@@emptyState.text.inactive:Inactive`;


  /* Pagination translations */

  public i18nOutOf: string = $localize`:@@general.pagination.outOf:out of`;

  public i18nAll: string = $localize`:@@general.pagination.all:All`;

  public i18nCustomerResults: string = $localize`:@@general.pagination.customerResults:Customer Results`;

  public i18nAssignedCustomers: string = $localize`:@@general.pagination.assignedCustomer:Assigned customers`;

  public i18nAttribute: string = $localize`:@@general.pagination.attribute:Attribute`;

  public i18nMaxTicketCount: string = $localize`:@@general.pagination.maxTicketCount:Max. Ticket Count`;

  constructor() { }
}
